class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.maTimerInterval = null;

    /*
    =========================================================
    ESC
    =========================================================
    */

    this.addEventListener(
      'keyup',
      (evt) => {
        if (evt.code === 'Escape') {
          this.close();
        }
      }
    );


    /*
    =========================================================
    CHECKOUT MAISON

    IMPORTANTE:

    Nuestro drawer utiliza inputs updates[] porque Dawn los
    necesita para quantity/remove.

    Pero NO queremos volver a enviar esos inputs cuando el
    cliente pulsa FINALIZAR COMPRA.

    El carrito ya está correctamente guardado en Shopify.

    Por eso interceptamos el submit de checkout y enviamos
    directamente al checkout actual de Shopify.
    =========================================================
    */

    this.addEventListener(
      'submit',
      (event) => {
        const submitter = event.submitter;

        if (
          submitter &&
          submitter.id === 'CartDrawer-Checkout'
        ) {
          event.preventDefault();
          event.stopPropagation();

          window.location.assign('/checkout');
        }
      }
    );


    /*
    =========================================================
    OVERLAY
    =========================================================
    */

    const overlay =
      this.querySelector(
        '#CartDrawer-Overlay'
      );

    if (overlay) {
      overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }


    this.setHeaderCartIconAccessibility();
  }



  /* ========================================================
     HEADER CART BUTTON
  ======================================================== */

  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector(
        '#cart-icon-bubble'
      );

    if (!cartLink) {
      return;
    }


    cartLink.setAttribute(
      'role',
      'button'
    );


    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );


    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.open(
          cartLink
        );
      }
    );


    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          event.preventDefault();

          this.open(
            cartLink
          );
        }
      }
    );
  }



  /* ========================================================
     TIMER
  ======================================================== */

  startMaisonTimer() {
    this.stopMaisonTimer();


    /*
    5 minutos.
    */

    let remaining =
      5 * 60;


    const render =
      () => {
        const timer =
          this.querySelector(
            '[data-ma-cart-timer]'
          );

        if (!timer) {
          return;
        }


        const minutes =
          Math.floor(
            remaining / 60
          );


        const seconds =
          remaining % 60;


        timer.textContent =
          `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      };


    /*
    Render inmediato:
    05:00
    */

    render();


    this.maTimerInterval =
      window.setInterval(
        () => {
          remaining -= 1;


          if (remaining <= 0) {
            remaining = 0;

            render();

            this.stopMaisonTimer();

            return;
          }


          render();
        },
        1000
      );
  }



  stopMaisonTimer() {
    if (
      this.maTimerInterval
    ) {
      window.clearInterval(
        this.maTimerInterval
      );

      this.maTimerInterval = null;
    }
  }



  /* ========================================================
     OPEN
  ======================================================== */

  open(triggeredBy) {
    /*
    Si ya está abierto, una actualización AJAX
    NO debe reiniciar el contador.
    */

    if (
      this.classList.contains(
        'active'
      )
    ) {
      return;
    }


    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }


    /*
    Cada apertura REAL:
    vuelve a 05:00.
    */

    this.startMaisonTimer();


    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );


    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute(
        'role'
      )
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }


    setTimeout(
      () => {
        this.classList.add(
          'animate',
          'active'
        );
      }
    );


    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains(
            'is-empty'
          )
            ?
              this.querySelector(
                '.drawer__inner-empty'
              )
            :
              document.getElementById(
                'CartDrawer'
              );


        const focusElement =
          this.querySelector(
            '.drawer__inner'
          )
          ||
          this.querySelector(
            '.drawer__close'
          );


        if (
          containerToTrapFocusOn &&
          focusElement
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      {
        once: true
      }
    );


    document.body.classList.add(
      'overflow-hidden'
    );


    this
      .querySelector(
        'cart-drawer-items'
      )
      ?.dispatchViewEvent();
  }



  /* ========================================================
     CLOSE
  ======================================================== */

  close() {
    this.stopMaisonTimer();


    this.classList.remove(
      'active'
    );


    removeTrapFocus(
      this.activeElement
    );


    document.body.classList.remove(
      'overflow-hidden'
    );
  }



  /* ========================================================
     ACCESSIBILITY
  ======================================================== */

  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );


    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );


    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute(
        'id'
      )
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }


    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',

          !event.currentTarget
            .closest(
              'details'
            )
            .hasAttribute(
              'open'
            )
        );
      }
    );


    cartDrawerNote
      .parentElement
      ?.addEventListener(
        'keyup',
        onKeyUpEscape
      );
  }



  /* ========================================================
     AJAX RENDER
  ======================================================== */

  renderContents(parsedState) {
    /*
    Si veníamos de carrito vacío, el wrapper
    exterior mantiene is-empty.

    Hay que quitarlo manualmente.
    */

    this.classList.remove(
      'is-empty'
    );


    this.productId =
      parsedState.id;


    this
      .getSectionsToRender()
      .forEach(
        (section) => {
          const sectionElement =
            section.selector
              ?
                document.querySelector(
                  section.selector
                )
              :
                document.getElementById(
                  section.id
                );


          if (!sectionElement) {
            return;
          }


          const sectionHTML =
            parsedState.sections
            ?.
            [section.id];


          if (!sectionHTML) {
            return;
          }


          const newHTML =
            this.getSectionInnerHTML(
              sectionHTML,
              section.selector
            );


          if (
            typeof newHTML !==
            'string'
          ) {
            return;
          }


          sectionElement.innerHTML =
            newHTML;
        }
      );


    /*
    Volvemos a garantizar estado no-empty
    después del rerender.
    */

    this.classList.remove(
      'is-empty'
    );


    const items =
      this.querySelector(
        'cart-drawer-items'
      );


    if (items) {
      items.classList.remove(
        'is-empty'
      );
    }


    /*
    El overlay interior ha sido sustituido,
    por tanto recuperamos el listener.
    */

    setTimeout(
      () => {
        const overlay =
          this.querySelector(
            '#CartDrawer-Overlay'
          );


        if (overlay) {
          overlay.addEventListener(
            'click',
            this.close.bind(this)
          );
        }


        /*
        Si estaba cerrado:
        abre y empieza 05:00.

        Si ya estaba abierto:
        open() simplemente retorna.
        */

        this.open();
      }
    );
  }



  /* ========================================================
     SECTION PARSER
  ======================================================== */

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return '';
    }


    const parsedDocument =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );


    const element =
      parsedDocument.querySelector(
        selector
      );


    return element
      ?
        element.innerHTML
      :
        '';
  }



  /* ========================================================
     SECTIONS TO RENDER
  ======================================================== */

  getSectionsToRender() {
    return [
      {
        id:
          'cart-drawer',

        selector:
          '#CartDrawer'
      },

      {
        id:
          'cart-icon-bubble'
      }
    ];
  }



  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return null;
    }


    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(
        selector
      );
  }



  setActiveElement(
    element
  ) {
    this.activeElement =
      element;
  }
}



if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}



/* =========================================================
   CART DRAWER ITEMS
========================================================= */

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id:
          'CartDrawer',

        section:
          'cart-drawer',

        selector:
          '.drawer__inner'
      },

      {
        id:
          'cart-icon-bubble',

        section:
          'cart-icon-bubble',

        selector:
          '.shopify-section'
      }
    ];
  }
}



if (
  !customElements.get(
    'cart-drawer-items'
  )
) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}